import {IdentifierChunk} from "../../chunks/types/IdentifierChunk";

const RE_EXTRACTOR = /^\s*\((.*)\)\s*$/;

export function getNameFromIdentifierChunk(
  identifierChunk: IdentifierChunk
): string {
  const capture = identifierChunk.captures[0];
  const matches = RE_EXTRACTOR.exec(capture);
  return matches
    ? matches[1].replace("\\)", ")")
    : capture;
}
